import React from "react";

const ManageAllOrders = () => {
  return (
    <div className="max-w-7xl mx-auto px-4">
      <h2>Manage All Orders</h2>
    </div>
  );
};

export default ManageAllOrders;
